// extracted by mini-css-extract-plugin
export default {"listAvatar":"MR9ZM8kgOTNTjrNnF8zl","chipAvatar":"BctXAVGcZYd5tOPzQld4","unassignedIcon":"Zw6Gz2sWSZryoroZN37Q"};